module.exports = __webpack_public_path__ + "static/media/294472.48fe0b56.png";